import React from "react";
import classNames from "classnames";
import { AppLink, AppParagraph } from "@/shared/Components";
import styles from "./styles.module.scss";

interface Props {
  name: string;
  title: string;
  phone: string;
  mail: string;
}

export const ContactCardBody: React.FC<Props> = ({ name, title, phone, mail }) => {
  return (
    <div className={classNames(styles["card-info"], styles["flex-container"])}>
      <div className={classNames(styles["flex-container"])}>
        <AppParagraph size="xxs" textType="secondary">
          {title}
        </AppParagraph>
        <AppParagraph className={styles.name} size="md" weight="semibold" textType="primary">
          {name}
        </AppParagraph>
      </div>
      <div className={classNames(styles["flex-container"])}>
        <AppLink href={`phone:${phone}`} size="xs" textType="accent">
          {phone}
        </AppLink>
        <AppLink
          onClick={(e) => e.stopPropagation()}
          href={`mailto:${mail}`}
          textType="primary"
          size="xs"
          className={styles.email}
        >
          {mail}
        </AppLink>
      </div>
    </div>
  );
};
